export default {
  buttonText: 'Plus d\'information',
};
